import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import {
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM,
  PROPERTY_CHICAGO
} from 'utils/constants';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import filter from 'lodash/filter';
import PropertyItem from './PropertyItem';

export const StyledPropertySelect = styled.div`
  position: relative;
  z-index: 10;
  margin-bottom: 1em;

  .unselected-items {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

class PropertySelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      noDisplay: true
    };
  }

  setNoDisplay = isDisplay => {
    this.setState({ noDisplay: isDisplay });
  };

  toggleOpen = () => {
    this.setState({ open: !this.state.open });

    /* Set timeout for 1 sec to keep animation before hide item. */
    if (this.state.open) {
      setTimeout(() => this.setNoDisplay(true), 1000);
    } else {
      this.setNoDisplay(false);
    }
  };

  selectProperty = property => {
    const { onChange, value } = this.props;

    if (value !== property) {
      onChange({ value: property, label: property });
    }

    this.toggleOpen();
  };

  render() {
    const { value, theme } = this.props;
    const { open, noDisplay } = this.state;

    const items = [
      { value: PROPERTY_ATMORE, url: process.env.REACT_APP_BOOKING_URL_ATMORE },
      {
        value: PROPERTY_BETHLEHEM,
        url: process.env.REACT_APP_BOOKING_URL_BETHLEHEM
      },
      {
        value: PROPERTY_MONTGOMERY,
        url: process.env.REACT_APP_BOOKING_URL_MONTGOMERY
      },
      {
        value: PROPERTY_WETUMPKA,
        url: process.env.REACT_APP_BOOKING_URL_WETUMPKA
      },
      {
        value: PROPERTY_CHICAGO,
        url: process.env.REACT_APP_BOOKING_URL_CHICAGO
      }
    ];

    const selectedItem = filter(items, item => item.value === value);
    const unselectedItems = filter(items, item => item.value !== value);
    const topItem = selectedItem.length > 0 ? selectedItem[0] : items[0];

    return (
      <StyledPropertySelect>
        <PropertyItem
          value={topItem.value}
          isSelected={value === topItem.value}
          onClick={this.selectProperty}
          itemProps={{
            'aria-haspopup': 'listbox',
            'aria-label': 'Select which property to book with',
            'aria-pressed': open,
            'aria-expanded': open,
            id: 'propertySelectContainer'
          }}
          isOpen={true}
          noDisplay={false}
        />
        <div
          className="unselected-items"
          role="listbox"
          aria-labelledby="propertySelectContainer"
        >
          <TransitionGroup className="property-list">
            {unselectedItems.map((item, ind) => (
              <CSSTransition
                key={'key-' + ind}
                timeout={ind * 3000}
                classNames="property"
              >
                <PropertyItem
                  key={item.value}
                  value={item.value}
                  href={
                    theme.propertySelector.linkToPropertySite
                      ? item.url
                      : undefined
                  }
                  isSelected={value === item.value}
                  onClick={
                    theme.propertySelector.linkToPropertySite && item.url
                      ? undefined
                      : this.selectProperty
                  }
                  itemProps={{
                    role: 'option',
                    'aria-selected': value === item.value
                  }}
                  isOpen={open}
                  noDisplay={noDisplay}
                  timeouts={ind * 350}
                />
              </CSSTransition>
            ))}
          </TransitionGroup>
        </div>
      </StyledPropertySelect>
    );
  }
}

PropertySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  theme: PropTypes.object
};

export default withTheme(PropertySelect);
